import { VueConstructor } from 'vue/types';
export type MessageType = 'text' | 'loading' | 'success' | 'fail' | 'html';

export default {
  install(Vue: VueConstructor) {
    Vue.mixin({
      methods: {
        _message(type: MessageType, message: string, { duration = 3000, ...otherOptions } = {}) {
          this.$toast({
            type,
            message,
            position: 'top',
            duration,
            ...otherOptions,
          });
        },
        _errMessage(content: string, error: { errCode: number; errMsg: string }) {
          this.$nextTick(() => {
            this.$toast({
              type: 'text',
              message: `${content}，${error.errMsg || error}`,
              position: 'top',
            });
            console.error(error);
          });
        },
        _loading(message = '加载中...', { duration = 3000, ...otherOptions } = {}) {
          return this.$toast({
            type: 'loading',
            duration,
            position: 'top',
            message,
            ...otherOptions,
          });
        },
        _confirm({
          description,
          confirmText,
          cancelText,
        }) {
          return new Promise((resolve, reject) => {
            this.VJSBridge.sendToastOperation({
              description,
              confirmText,
              confirmCallback: () => {
                resolve('confirm');
              },
              cancelCallback: () => {
                reject('cancel');
              },
              cancelText,
            });
          });
        },
      },
    });
  },
};
